
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { useLocalization } from "gatsby-theme-i18n";
import { SectionFullWidthColumn,SectionRow } from '../../../components/CommonSection'; 
import Ticket from '../../../components/Ticket'; 
import AlertBox from '../../../components/AlertBox'
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import * as config from '../../../styles/config.module.scss';

const TicketSection = () => {
  const { t } = useLocalization();

  return(
      <SectionFullWidthColumn css={css`
        padding-bottom:48px;
      `}>
        <SectionTitle>{t('ticket.type.title')}</SectionTitle>
        <SectionRow css={css`
          @media only screen and (max-width: ${breakpoint.smMax}){
            width:100%;
          }
        `}>
          <Ticket 
            date={t('ticket.type.day1.ticket-only.date')} 
            title={t('ticket.type.day1.ticket-only.name')} 
            price={t('ticket.type.day1.ticket-only.price.value')} 
            type={"normal"}
          />
          <Ticket 
            date={t('ticket.type.day1.ticket-and-goods.date')} 
            title={t('ticket.type.day1.ticket-only.name')} 
            price={t('ticket.type.day1.ticket-and-goods.price.value')} 
            option={t('ticket.type.day1.ticket-and-goods.goods')}
            type={"withGoods"}
          />
        </SectionRow>
        <SectionRow css={css`
          @media only screen and (max-width: ${breakpoint.smMax}){
            width:100%;
          }
        `}>
          <Ticket 
            date={t('ticket.type.day2.ticket-only.date')} 
            title={t('ticket.type.day2.ticket-only.name')} 
            price={t('ticket.type.day2.ticket-only.price.value')} 
            type={"normal"}
          />
          <Ticket 
            date={t('ticket.type.day2.ticket-and-goods.date')} 
            title={t('ticket.type.day2.ticket-only.name')} 
            price={t('ticket.type.day2.ticket-and-goods.price.value')} 
            option={t('ticket.type.day1.ticket-and-goods.goods')}
            type={"withGoods"}
          />
        </SectionRow>
        <AlertContainer>
          <AlertBox iconType={'Alert'} iconColor={'#D00F31'} text={ t('ticket.type.attention')} type={'narrow'}/>
        </AlertContainer>
      </SectionFullWidthColumn>
  );
}

export default TicketSection;


const SectionTitle = styled.h2`
  font-size: ${config.fontSizeH1};
  display:block;
  margin-bottom:48px;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    text-align:center;
    font-size: ${config.fontSizeSMH1};
    margin-bottom:32px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: ${config.fontSizeXSH1};
  }

`
const AlertContainer = styled.div`
  padding-top:16px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding-top:0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding-top:16px;
  }
`
